import { useEffect } from 'react';

import usePostPing from 'Domain/monitoring/usePostPing';

const Ping = ({ monitoringStatus, isOpenChangeDeviceModal }) => {
  const PING_DURATION = 3 * 60000;

  const { mutate: postPing } = usePostPing();
  const isStartPing = monitoringStatus?.status === 'CLOCKED_IN_ACTIVE' || monitoringStatus?.status === 'ON_BREAK';

  useEffect(() => {
    if (isStartPing && !isOpenChangeDeviceModal) {
      postPing(monitoringStatus);

      const timer = setInterval(() => postPing(monitoringStatus), PING_DURATION);
      return () => clearInterval(timer);
    }

    /* eslint-disable */
  }, [isStartPing, isOpenChangeDeviceModal]);

  return <></>;
};

export default Ping;
